import { money } from "./cart";

export const strengthsLabel = (p) => (p.variants || []).map((v) => v.strength).join(" · ");

export const priceLabel = (p) => {
  const prices = (p.variants || []).map((v) => v.price_cents);
  if (!prices.length) return "";
  const min = Math.min(...prices);
  return prices.some((c) => c !== min) ? `From ${money(min)}` : money(min);
};

const MASS_STRENGTH = /\d\s*(mcg|µg|ug|mg|iu)\b/i;

// "Strength" for mg-type research options, "Size" for volume/weight (e.g. 5 mL, 30 g) and skincare.
export const optionKind = (p) => {
  const vs = p.variants || [];
  if (vs.length && vs.every((v) => MASS_STRENGTH.test(v.strength))) return "Strength";
  if (p.category === "skincare") return "Size";
  return vs.some((v) => MASS_STRENGTH.test(v.strength)) || !vs.length ? "Strength" : "Size";
};

export const isSkincare = (p) => p?.category === "skincare";

export const detailPath = (p) => (isSkincare(p) ? `/skincare/${p.id}` : `/product/${p.id}`);
